<template>
  <div>
    <v-btn-toggle class="d-flex flex-warp mt-2" v-model="dateSelectedIndex" borderless mandatory tile>
      <div style="width: 100%">
        <template v-for="date in dateTimeList">
          <v-btn class="white--text" color="primary" :key="date" :width="dateSelectBtnWidth()" elevation="0" tile>
            {{ date }}
          </v-btn>
        </template>
      </div>
    </v-btn-toggle>

    <v-sheet color="blue-grey lighten-1">
      <v-text-field
        name="name"
        label="Search by Session Name"
        v-model="searchText"
        class="pa-2"
        prepend-inner-icon="mdi-magnify"
        rounded
        solo
        hide-details
        dense
      ></v-text-field>
    </v-sheet>

    <template v-for="{ id, name, sessions } in trackList">
      <v-list-group class="primary" value="true" :key="id">
        <template v-slot:activator>
          <v-list-item-title class="white--text d-flex" style="width: 100vh;">{{ name }}</v-list-item-title>
        </template>

        <v-list class="pa-0">
          <v-list-item class="pa-0" v-for="(session, i) in sessions" :key="session.id">
            <v-list-item-content :class="[i !== 0 ? 'border-top' : '', 'pa-0']">
              <session-card v-bind="session"></session-card>
            </v-list-item-content>
          </v-list-item>

          <v-list-item class="pa-0" v-if="sessions.length === 0">
            <v-list-item-content class="text-center">
              <span>no data</span>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-list-group>
    </template>

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Fuse from "fuse.js";
import apiTrack from "@/apis/Track";
import SessionCard from "@/components/Card/Session";

export default {
  name: "SessionList",
  components: { SessionCard },
  data() {
    return {
      searchText: "",
      dataList: [],
      dateSelectedIndex: 0,
      loading: true
    };
  },
  watch: {
    dateSelectedIndex() {
      if (this.$route.hash !== `#${this.dateSelected}`) this.$router.replace({ hash: `#${this.dateSelected}` });
    }
  },
  computed: {
    dateSelected: {
      get() {
        return this.dateTimeList[this.dateSelectedIndex];
      },
      set(val) {
        this.dateSelectedIndex = this.dateTimeList.findIndex(date => date === val);
      }
    },
    dateTimeList() {
      const result = [];
      const { start_date, end_date } = this.$store.state.conference;

      const startDate = this.$dayjs(start_date).utc();
      const endDate = this.$dayjs(end_date).utc();

      for (let i = 0; i <= endDate.diff(startDate, "d"); i++) {
        const date = startDate.add(i, "d");
        result.push(date.format("YYYY-MM-DD"));
      }

      return result;
    },
    dateClassificationList() {
      const filterDate = time => {
        const startTime = this.$dayjs(time).subtract(8, "h");
        const dateSelectedBegin = this.$dayjs(this.dateSelected).startOf("d");
        const dateSelectedEnd = this.$dayjs(this.dateSelected).endOf("d");

        return startTime.isBetween(dateSelectedBegin, dateSelectedEnd, null, "[)");
      };

      const sortTime = (a, b) => {
        const timeStartA = this.$dayjs(a.start_time);
        const timeStartB = this.$dayjs(b.start_time);

        if (timeStartA.isBefore(timeStartB)) return -1;
        if (timeStartB.isBefore(timeStartA)) return 1;

        return 0;
      };

      return this.dataList.map(({ sessions, ...org }) => ({
        sessions: sessions.filter(({ start_time }) => filterDate(start_time)).sort(sortTime),
        ...org
      }));
    },
    trackList() {
      if (this.searchText === "") return this.dateClassificationList;
      return this.searchList;
    },
    searchList() {
      return this.dateClassificationList.map(({ sessions, ...arg }) => {
        const options = {
          keys: ["title_en", "title_zh"]
        };

        const fuse = new Fuse(sessions, options);
        const result = fuse.search(this.searchText);

        return { sessions: result.map(({ item }) => item), ...arg };
      });
    }
  },
  methods: {
    dateSelectBtnWidth() {
      const length = this.dateTimeList.length;

      if (length % 2 === 1) {
        return "100%";
      } else {
        return "50%";
      }
    },
    async fetchData() {
      const params = new URLSearchParams({ populate: "sessions" });
      this.dataList = await apiTrack.get(null, params);

      this.loading = false;
    }
  },
  async created() {
    this.dateSelected = this.$route.hash.slice(1);

    await this.fetchData();
  }
};
</script>

<style></style>
